<template>
  <div>
    <a-button type="primary" :style="{ margin: '0 0 24px 0' }" @click="add"
      >新增</a-button
    >
    <a-modal v-model="visible" centered title="添加商家" @ok="handleOk">
      <p>商家名称</p>
      <a-input v-model="form.name" placeholder="请输入商家名称"></a-input>
      <p>商家商户</p>
      <a-input v-model="form.partner_id" placeholder="请输入商家商户ID" type="number"></a-input>
      <p>比例</p>
      <a-input v-model="form.ratio" placeholder="请输入比例数值" type="number"></a-input>
      <p>会员每天兑换限额</p>
      <a-input v-model="form.member_limit" placeholder="请输入额度,默认0不限额" type="number"></a-input>
      <p>查账密码</p>
      <a-input v-model="form.password" placeholder="请输入密码" ></a-input>
    </a-modal>
    <a-modal v-model="visibletwo" centered title="编辑商家" @ok="handleOktwo">
      <p>姓名</p>
      <a-input v-model="forms.name" placeholder="请输入商家名称"></a-input>
      <p>商家商户</p>
      <a-input v-model="forms.partner_id" placeholder="请输入商家商户ID" type="number"></a-input>
      <p>比例</p>
      <a-input v-model="forms.ratio" placeholder="请输入比例数值" type="number"></a-input>
      <p>会员每天兑换限额</p>
      <a-input v-model="forms.member_limit" placeholder="请输入额度，默认0不限额" type="number"></a-input>
   
    </a-modal>
    <a-modal
      v-model="ifImg"
      title="商家二维码"
      @ok="handleQC(operate)"
      cancelText="取消"
      okText="确定"
    >
      <div>
        <el-button @click="downloadCodeImg()">点击下载二维码</el-button>
      </div>
      <img
        :src="img"
        style="width: 200px; height: 200px; margin-left: 100px"
        alt="商家二维码"
        @error="handleImgError"
        v-show="img"
      />
      <div v-if="!img" style="text-align: center; padding: 100px 0;">
        <a-spin tip="加载中..." />
      </div>
    </a-modal>
    
    <a-table
      :columns="columns"
      :row-key="record => record.objId"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="operate" slot-scope="text, operate">
        <a href="javascript:;" @click="edit(operate)">编辑</a>
        <a href="javascript:;" v-on:click.prevent="showImg(operate)">
          商家二维码
        </a>
        <a href="javascript:;" v-on:click.prevent="showImg2(operate)">
          商家查账二维码
        </a>
        <a href="javascript:;" v-on:click.prevent="rest(operate)">
          重置密码
        </a>
        <a href="javascript:;" @click="del(operate)">删除</a>
      </template>
    </a-table>
  </div>
</template>
<script>
import {
  storeAddNearbyShop,
  storeUpdateNearbyShop,
  storeDelNearbyShop,
  storeGetNearbyShopList,
  storeGetNearbyShopInfo,
  getPartnerImg,
  getPartnerReportImg,
  restPwd
} from "@/api/storeApi.js";
import { message } from "ant-design-vue";

const columns = [
  {
    title: "ID",
    dataIndex: "objId",
    align: "center",
    scopedSlots: { customRender: "objId" }
  },
  {
    title: "商家名称",
    dataIndex: "name",
    align: "center",
    scopedSlots: { customRender: "name" }
  },
  {
    title: "商家商户",
    dataIndex: "partner_id",
    align: "center",
    scopedSlots: { customRender: "partner_id" }
  },
  {
    title: "比例",
    dataIndex: "ratio",
    align: "center",
    scopedSlots: { customRender: "ratio" }
  },
  {
    title: "会员每天兑换限额",
    dataIndex: "member_limit",
    align: "center",
    scopedSlots: { customRender: "member_limit" }
  },
  {
    title: "操作",
    dataIndex: "operate",
    scopedSlots: { customRender: "operate" }
  }
];

export default {
  data() {
    return {
      data: [],
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: total => `共 ${total} 条`,
        pageSize: 10
      },
      loading: false,
      columns,
      img: "",
      ifImg: false,
      visible: false,
      visibletwo: false,
      form: {
        name: "",
        partner_id: null,
        ratio: null,
        member_limit: null,
        password: ""
      },
      forms: {
        objId: "",
        name: "",
        partner_id: null,
        ratio: null,
        member_limit: null
      }
    };
  },
  mounted() {
    this.getData();
  },
  props: ["formInline"],
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    handleTableChange(pagination, filters, sorter) {
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      storeGetNearbyShopList( this.pagination.current ,this.pagination.pageSize).then(res => {
        this.data = res.data;
        this.loading = false;
      });
    },
    edit(row) {
      this.visibletwo = true;
      this.forms.objId = row.objId;
      this.forms.name = row.name;
      this.forms.partner_id = row.partner_id;
      this.forms.ratio = row.ratio;
      this.forms.member_limit = row.member_limit;
    },
    handleQC(e) {
      this.ifImg = false;
    },
    showImg(row) {
      console.log("showImg:", row);
      this.ifImg = true;
      getPartnerImg(row.partner_id).then(res => {
        console.log("showImg res ------", res);
        // 确保数据正确赋值，处理可能的多种返回格式
        if (res && res.data) {
          this.img = res.data;
        } else {
          this.img = '';
          message.error('获取二维码失败');
        }
        console.log("图片 URL:", this.img);
      }).catch(err => {
        console.error("获取二维码错误:", err);
        message.error('获取二维码失败，请重试');
      });
    },

    showImg2(row) {
      console.log("showImg2:", row);
      this.ifImg = true;
      getPartnerReportImg(row.partner_id).then(res => {
        console.log("showImg2 res ------", res);
        // 确保数据正确赋值，处理可能的多种返回格式
        if (res && res.data) {
          this.img = res.data;
        } else {
          this.img = '';
          message.error('获取二维码失败');
        }
        console.log("图片 URL:", this.img);
      }).catch(err => {
        console.error("获取二维码错误:", err);
        message.error('获取二维码失败，请重试');
      });
    },
    handleImgError() {
      console.error('图片加载失败:', this.img);
      // message.error('二维码图片加载失败，可能是网络问题或图片地址无效');
    },
    rest(row) {
      restPwd(row.partner_id).then(res => {
        message.info(res.info);
      });
    },
    // 下载图片
    downloadCodeImg() {
      console.log("下载图片");
      var a = document.createElement("a");
      a.download = name || "pic";
      // 设置图片地址
      a.href = this.img;
      a.click();
    },
    // 查询
    query() {
      this.loading = true;
      storeGetNearbyShopInfo(this.formInline.name,this.pagination.current,this.pagination.pageSize).then(res => {
        if(res.data.length === 0){
            message.warning("没有数据");
            this.data = [];
            this.pagination.total = 0;
            this.loading = false;
            return;
        }
        this.pagination.total = res.data.count;
        this.data = res.data.data;
        this.loading = false;
      });
    },
    del(row) {
      this.loading = true;
      storeDelNearbyShop(row.objId).then(res => {
        this.loading = false;
        this.getData();
        message.success(res.info);
      });
    },
    add() {
      this.visible = true;
      // 重新初始化表单，确保类型正确
      this.form = {
        name: "",
        partner_id: null,
        ratio: null,
        member_limit: null
      };
    },
    handleOk() {
      if (!this.form.name) {
        message.warning("名称不能为空");
        return;
      }
      if (!this.form.partner_id) {
        message.warning("商家商户不能为空");
        return;
      }
      // 显式转换为数字类型并验证
      const partnerId = Number(this.form.partner_id);
      const ratio = Number(this.form.ratio);
      const member_limit = Number(this.form.member_limit);
      
      if (isNaN(partnerId) || partnerId <= 0) {
        message.warning("商家商户必须是有效的正整数");
        return;
      }
      if (isNaN(ratio) || ratio <= 0) {
        message.warning("比例必须是有效的正数");
        return;
      }
      if (isNaN(member_limit) || member_limit < 0) {
        message.warning("会员额度比例必须是非负数");
        return;
      }
      // 创建新的表单对象，确保使用正确的数据类型
      const submitForm = {
        name: this.form.name,
        partner_id: partnerId,
        ratio: ratio,
        member_limit: member_limit,
        password: this.form.password
      };
      
      this.visible = false;
      console.log("submit form data:", submitForm);
      storeAddNearbyShop(submitForm).then(res => {
        message.success(res.info);
        this.getData();
         this.form = {
                name: "",
                partner_id: null,
                ratio: null,
                member_limit: null
            };
        console.log("form:", this.form);
      });
    },
    handleOktwo() {
      console.log("handleOktwo:", this.forms);
      if (!this.forms.name) {
        message.warning("姓名不能为空");
        return;
      }
      if (!this.forms.partner_id) {
        message.warning("商家商户不能为空");
        return;
      }
      
      // 显式转换为数字类型并验证
      const partnerId = Number(this.forms.partner_id);
      const ratio = Number(this.forms.ratio);
      const member_limit = Number(this.forms.member_limit);
      
      if (isNaN(partnerId) || partnerId <= 0) {
        message.warning("商家商户必须是有效的正整数");
        return;
      }
      if (isNaN(ratio) || ratio <= 0) {
        message.warning("比例必须是有效的正数");
        return;
      }
      if (isNaN(member_limit) || member_limit < 0) {
        message.warning("会员额度比例必须是非负数");
        return;
      }
      
      // 创建新的表单对象，确保使用正确的数据类型
      const submitForms = {
        objId: this.forms.objId,
        name: this.forms.name,
        partner_id: partnerId,
        ratio: ratio,
        member_limit: member_limit
      };
      console.log("update submit forms:", submitForms);
      
      this.visibletwo = false;
      storeUpdateNearbyShop(submitForms).then(res => {
        message.success(res.info);
        this.getData();
      });
    },
    getData() {
      storeGetNearbyShopList(this.pagination.current,this.pagination.pageSize).then(res => {
        // console.log("getData res ------", res);
        if(res.data.length === 0){
            message.warning("没有数据");
            this.data = [];
            this.pagination.total = 0;
            this.loading = false;
            return;
        }
        this.pagination.total = res.data.count;
        this.data = res.data.data;
      });
    }
  }
};
</script>
<style scoped>
img {
  width: 110px;
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/storeManagement/partnerManagement/partnerContent.vue